import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Question } from '@core/models/question.model';
import { WORD_CLOUD_CONSTANTS } from '@core/constants/push-live.constants';
import { countWordCloudWords } from '@core/utils/word-cloud.util';

@Component({
  selector: 'app-word-cloud',
  templateUrl: './word-cloud.component.html',
  styleUrls: ['./word-cloud.component.css'],
})
export class WordCloudComponent {
  @Input() isMissing = false;
  @Input() question!: Question;
  @Input() index!: number;
  @Output() answerSelected = new EventEmitter<{
    questionUuid: string;
    answerValue: string;
  }>();

  readonly maxWords = WORD_CLOUD_CONSTANTS.MAX_WORDS;
  readonly maxLength = WORD_CLOUD_CONSTANTS.MAX_LENGTH;
  readonly inputHint = WORD_CLOUD_CONSTANTS.INPUT_HINT;
  wordCount = 0;

  get isOverLimit(): boolean {
    return this.wordCount > this.maxWords;
  }

  handleInput(event: Event): void {
    const value = (event.target as HTMLInputElement).value;
    this.wordCount = countWordCloudWords(value);

    this.answerSelected.emit({
      questionUuid: this.question.uuid,
      answerValue: value,
    });
  }

  get questionHtml(): string {
    const html = this.question.question || '';
    if (!this.question.is_required) {
      return html;
    }
    const marker = ' <span style="color:#dc2626">*</span>';
    const lastCloseTagIndex = html.toLowerCase().lastIndexOf('</p>');
    if (lastCloseTagIndex === -1) {
      return html + marker;
    }
    return html.slice(0, lastCloseTagIndex) + marker + html.slice(lastCloseTagIndex);
  }
}
